// Backlog 109 layer A (2026-10-07): away means not Available.
//
// Amazon Connect rings an Available agent for 20 seconds (not configurable)
// before moving the caller on, and it keeps an agent's last status when the
// browser is closed. On 2026-10-07 a caller waited 30 s because the call rang
// an unattended Available login first. These rules let the agent's OWN console
// take them out of rotation; nobody edits another agent's status.
//
//   1. a ring this console missed        -> Offline
//   2. idle while Available              -> "Still there?" for 60 s, then Offline
//   3. the console checks in with the server every 30 seconds, and tells it
//      when the tab is closing. The SERVER (lambdas/knktr-agent-presence) sets
//      an Available agent Offline when their console goes quiet. A status
//      change sent from the page itself as it closed never arrived (tried
//      2026-10-07), so the page no longer attempts one.
//
// Pure decisions only, so they can be tested without a browser. The hook that
// applies them is hooks/useAwayGuard.js.

export const IDLE_PROMPT_MS = 15 * 60 * 1000;   // Storm 2026-10-07: prompt after 15 minutes idle
export const IDLE_COUNTDOWN_MS = 60 * 1000;     // ...then 60 seconds to answer it
export const TICK_MS = 5 * 1000;
export const HEARTBEAT_MS = 30 * 1000;          // the server treats 3 minutes of silence as away
export const AVAILABLE = 'Available';
export const OFFLINE = 'Offline';

// Anything the agent is doing with a contact. Never go Offline under them.
export function isBusy({ callActive, dialling, incomingContact, acwActive, display } = {}) {
  return !!(callActive || dialling || incomingContact || acwActive || display);
}

// What the idle rule should do on this tick.
//   'none'    nothing
//   'prompt'  show "Still there?"
//   'cancel'  hide the prompt (the agent came back, got busy, or is no longer Available)
//   'offline' the countdown ran out: go Offline
export function idleStep({ status, busy, lastActivityAt, promptAt, now }) {
  if (status !== AVAILABLE || busy) return promptAt ? 'cancel' : 'none';
  if (promptAt) {
    if (lastActivityAt > promptAt) return 'cancel';
    return now - promptAt >= IDLE_COUNTDOWN_MS ? 'offline' : 'none';
  }
  return now - lastActivityAt >= IDLE_PROMPT_MS ? 'prompt' : 'none';
}

export function secondsLeft(promptAt, now) {
  if (!promptAt) return 0;
  return Math.max(0, Math.ceil((promptAt + IDLE_COUNTDOWN_MS - now) / 1000));
}

// After a missed ring Connect already stops routing to this agent, but their
// status still reads Available to everyone else and the next ring after they
// clear the notice could be missed again. Go Offline unless already there.
export function shouldGoOfflineOnMiss({ status } = {}) {
  return status !== OFFLINE;
}

// The presence endpoint sits beside the data endpoint the build already has,
// so it needs no build input of its own. No data address = no presence calls.
export function presenceUrl(dataUrl) {
  const u = String(dataUrl || '');
  return /\/data$/.test(u) ? u.replace(/\/data$/, '/presence') : '';
}

export const NOTICE_TEXT = {
  missed: 'You missed a call, so you have been set to Offline. Callers are not waiting on you.',
  idle: 'No activity for a while, so you have been set to Offline. Callers are not waiting on you.',
};
